import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	actions: {
		display: "flex",
		justifyContent: "flex-end",
		gap: 4,
	},
	empty: {
		padding: theme.spacing(3),
		textAlign: "center",
		color: theme.palette.custom.textSecondary,
	},
} satisfies Record<string, CSSObject>);
